<script lang="ts">
    import { dialog_closeNewAutomaton } from "../actions/dialog";
    import { machineState_newMachine } from "../actions/machineState";
    import { getState } from "../context";
    import { MealyModelType } from "../mealyModels/mealyModelType";
    import Dialog from "./Dialog.svelte";
    import * as F from 'fp-ts/function';

    const state = getState();
    $: dialogState = $state.dialogState;

    function close() {
        state.set(dialog_closeNewAutomaton($state));        
    }

    function handleCancelClick() {
        state.set(dialog_closeNewAutomaton($state));
    }

    function newAutomaton(system: MealyModelType) {
        const newState = F.pipe(
            $state,
            dialog_closeNewAutomaton,
            machineState_newMachine(system),
        );
        state.set(newState);
    }
    
    function handleDoorSystemClick() {
        newAutomaton(MealyModelType.DOORSYSTEM);
    }

    function handleKunstautomat1Click() {
        newAutomaton(MealyModelType.KUNSTAUTOMAT1);
    }

    function handleKunstautomat2Click() {
        newAutomaton(MealyModelType.KUNSTAUTOMAT2);
    }

    function handleAmpelClick() {
        newAutomaton(MealyModelType.AMPELSYSTEM);
    }

    function handleGaragentorClick() {
        newAutomaton(MealyModelType.GARAGENTOR);
    }

    function handleCodeschlossClick() {
        newAutomaton(MealyModelType.CODESCHLOSS);
    }
</script>

<Dialog isOpen={dialogState.newProject.isOpen} on:close={close}>
    <p>Neuer Automat</p>
    <p>Wähle das System, das gesteuert werden soll:</p>
    <button on:click={handleDoorSystemClick}>Türsystem</button>
    <button on:click={handleKunstautomat1Click}>Kunstautomat (1€)</button>
    <button on:click={handleKunstautomat2Click}>Kunstautomat (1€, 2€)</button>
    <button on:click={handleAmpelClick}>Ampel</button>
    <button on:click={handleGaragentorClick}>Garagentor</button>
    <button on:click={handleCodeschlossClick}>Tür mit Zahlenschloss</button>

    <div style="display: flex; justify-content: space-evenly">
        <button class="dsimweb-button" on:click={handleCancelClick}>Abbrechen</button>
    </div>
</Dialog>